import requests from "../util";

const { request } = requests;

export const fetchRequestTypes = () => {
  return request({
    url: "/api/v1/request/types",
    method: "get",
  });
};

export const fetchRequests = (pageNum, pageSize, stage) => {
  const params = {
    pageNum,
    pageSize,
    stage,
  };

  return request({
    url: "/api/v1/request",
    method: "get",
    params,
  });
};

export const approveRequest = (requestId) => {
  return request({
    url: "/api/v1/request/approve",
    method: "patch",
    body: { requestId },
  });
};

export const rejectRequest = (requestId) => {
  return request({
    url: "/api/v1/request/reject",
    method: "patch",
    body: { requestId },
  });
};

export const raiseRequest = ({ requestType, comment, requestData }) => {
  return request({
    url: "/api/v1/request",
    method: "post",
    body: { requestType, comment, requestData },
  });
};
